import { cn } from "@/lib/utils";
import { ExtensionLink } from "components/core/ExtensionLink";
import { Text } from "components/core/Text";
import { ComponentProps } from "react";

export const ContentTags = ({
    tags,
    color,
    className,
    disableLinks = false,
    ...props
}: {
    tags: Mix_ContentFragment["mix_content_tags"];
    color?: ComponentProps<typeof Text>["color"];
    className?: string;
    /** <a> 태그 중첩을 방지하기 위해 링크 대신 span으로 렌더링 (카드가 이미 <a>로 감싸진 경우) */
    disableLinks?: boolean;
}) => {
    return (
        <div
            className={cn("flex items-center overflow-hidden", className)}
            {...props}
        >
            {tags.map((tag, index) => (
                <span
                    key={tag.mix_content_tag_enum.value}
                    className="inline-flex items-center overflow-y-auto"
                >
                    {disableLinks ? (
                        <span
                            className="flex w-max items-center justify-center
                                truncate text-ellipsis rounded-lg
                                bg-[#638FFF]/10 px-2 py-1 dark:bg-gray-700"
                        >
                            <Text
                                variant="body4"
                                className="text-blue-400 dark:text-blue-300"
                            >
                                {tag.mix_content_tag_enum.comment}
                            </Text>
                        </span>
                    ) : (
                        <ExtensionLink
                            href={`/?tag=${tag.mix_content_tag_enum.value}`}
                            onClick={(e) => e.stopPropagation()}
                            className="group/tag flex w-max items-center
                                justify-center truncate text-ellipsis rounded-lg
                                bg-[#638FFF]/10 px-2 py-1 transition-all
                                duration-200 ease-out dark:bg-gray-700"
                        >
                            <Text
                                variant="body4"
                                className="text-blue-400 transition-all duration-200
                                    ease-out group-hover/tag:font-bold
                                    dark:text-blue-300"
                            >
                                {tag.mix_content_tag_enum.comment}
                            </Text>
                        </ExtensionLink>
                    )}
                    {index < tags.length - 1 && <div className="mx-1" />}
                </span>
            ))}
        </div>
    );
};
